import React from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {AltaBody} from './AltaBody'
import {AltaContextProvider} from './AltaContext'
import {AltaHeader} from './AltaHeader'
import {ExportFiledModal} from './export/ExportFiledModal'

const AltaBreadcrumbs = [
  {
    title: 'Alta colaboradores',
    path: '/seguimiento/alta',
    isSeparator: false,
    isActive: false,
  },
]

const AltaPage: React.FC = () => {
  return (
    <>
      <BasicBreadcrumbs breadcrumbs={AltaBreadcrumbs} fallbackTitle='Alta colaboradores' />
      <KTCard>
        <KTCardBody>
          <AltaContextProvider>
            <AltaHeader />
            <AltaBody />
            <ExportFiledModal />
          </AltaContextProvider>
        </KTCardBody>
      </KTCard>
    </>
  )
}

export default AltaPage
